var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.3335C6.95833 18.3335 5.98264 18.1356 5.07292 17.7397C4.16319 17.3439 3.37153 16.8092 2.69792 16.1356C2.02431 15.462 1.48958 14.6703 1.09375 13.7606C0.697917 12.8509 0.5 11.8752 0.5 10.8335H2.16667C2.16667 12.4585 2.73264 13.837 3.86458 14.9689C4.99653 16.1009 6.375 16.6668 8 16.6668C9.625 16.6668 11.0035 16.1009 12.1354 14.9689C13.2674 13.837 13.8333 12.4585 13.8333 10.8335C13.8333 9.2085 13.2674 7.83002 12.1354 6.69808C11.0035 5.56613 9.625 5.00016 8 5.00016H7.875L9.16667 6.29183L8 7.50016L4.66667 4.16683L8 0.833496L9.16667 2.04183L7.875 3.3335H8C9.04167 3.3335 10.0174 3.53141 10.9271 3.92725C11.8368 4.32308 12.6285 4.8578 13.3021 5.53141C13.9757 6.20502 14.5104 6.99669 14.9062 7.90641C15.3021 8.81613 15.5 9.79183 15.5 10.8335C15.5 11.8752 15.3021 12.8509 14.9062 13.7606C14.5104 14.6703 13.9757 15.462 13.3021 16.1356C12.6285 16.8092 11.8368 17.3439 10.9271 17.7397C10.0174 18.1356 9.04167 18.3335 8 18.3335Z",
    fill: "#0072C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.8f2a4d0f5d140edd319a4904404e2ef6.svg";
export { ForwardRef as ReactComponent };